import React from 'react';
import { Button } from './ui/button';
import { Search, FileCheck, Bell, Shield, AlertTriangle, Eye } from 'lucide-react';

const ServicesSection = ({ openPopup }) => {
  const services = [
    {
      icon: Search,
      title: "Comprehensive Trademark Search",
      description: "Thorough analysis of existing trademarks, pending applications, and common law uses to identify potential conflicts before filing. Our extensive database search minimizes rejection risks and ensures your mark's availability.",
      features: [
        "Federal trademark database search",
        "State trademark registry review",
        "Common law trademark investigation",
        "Detailed conflict analysis report"
      ]
    },
    {
      icon: FileCheck,
      title: "USPTO Filing & Registration",
      description: "Expert preparation and filing of your trademark application with the United States Patent and Trademark Office. We handle all documentation, classifications, and technical requirements for accurate submission.",
      features: [
        "Complete application preparation",
        "Proper class identification",
        "Specimen and documentation gathering",
        "Electronic USPTO filing (TEAS)"
      ]
    },
    {
      icon: AlertTriangle,
      title: "Office Action Response",
      description: "Professional handling of USPTO objections, refusals, and office actions. Our experienced attorneys craft persuasive responses to overcome legal obstacles and secure your trademark approval.",
      features: [
        "Legal analysis of office actions",
        "Strategic response preparation",
        "Argument development and evidence",
        "Follow-up communication with USPTO"
      ]
    },
    {
      icon: Shield,
      title: "Brand Protection Strategy",
      description: "Comprehensive brand protection planning to safeguard your intellectual property. We develop customized strategies to defend your trademark rights and maintain market exclusivity.",
      features: [
        "Trademark portfolio management",
        "Infringement prevention strategies",
        "Cease and desist letter preparation",
        "Brand expansion guidance"
      ]
    },
    {
      icon: Bell,
      title: "Trademark Monitoring",
      description: "Continuous surveillance of new trademark applications and registrations to detect potential infringements. Stay informed about marks that could conflict with your brand identity.",
      features: [
        "Automated trademark watch services",
        "Monthly monitoring reports",
        "Conflict notification alerts",
        "Competitor trademark tracking"
      ]
    },
    {
      icon: Eye,
      title: "Trademark Maintenance",
      description: "Timely reminder and filing services for required maintenance documents. We ensure your trademark registration remains active and protected through all renewal deadlines.",
      features: [
        "Declaration of Use filing (5-6 years)",
        "Renewal filing assistance (every 10 years)",
        "Deadline tracking and reminders",
        "Ongoing compliance management"
      ]
    }
  ];

  return (
    <section className="services-section" id="services">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Our Trademark Services</span>
          <h2 className="section-title">
            Comprehensive Trademark Registration
            <span className="title-highlight"> Solutions</span>
          </h2>
          <p className="section-description">
            From initial trademark search to ongoing brand protection, we provide end-to-end 
            trademark registration services designed to secure and defend your brand identity 
            in the competitive marketplace.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div key={index} className="service-card">
                <div className="service-card-header">
                  <div className="service-card-icon">
                    <Icon size={28} />
                  </div>
                  <h3 className="service-card-title">{service.title}</h3>
                </div>
                <p className="service-card-description">{service.description}</p>
                <ul className="service-features-list">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="service-feature-item">
                      <span className="feature-checkmark">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="services-cta">
          <div className="services-cta-content">
            <h3 className="services-cta-title" style={{color: 'white'}}>Need Expert Guidance on Trademark Registration?</h3>
            <p className="services-cta-text" style={{color: 'white'}}>
              Our trademark specialists are ready to discuss your brand protection needs and 
              recommend the best service package for your business.
            </p>
            <Button onClick={openPopup} className="services-cta-button" size="lg">
              Get Free Consultation
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
